// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1___ad9fed015844b9722e6","cls2":"UserTaggingPingBodyStyles-cls2___154613b1e8110683b15 UserTaggingPingBodyStyles-cls1___ad9fed015844b9722e6"};